import { Form, OverlayTrigger, Tooltip } from 'react-bootstrap'
import Navbar from '../../components/navbar/navbar'
import React, { useEffect, useRef, useState } from 'react'
import { CustomButton } from '../../components/CustomButton'
import {
  CheckCircle,
  CheckCircleFill,
  Clock,
  PatchCheckFill,
  Search,
} from 'react-bootstrap-icons'

import { formatDate } from '../../utils/formatDate'
import apinode from '../../services/apinode'

import PedidosService from '../../services/database/PedidosService'
import Swal from 'sweetalert2'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

import beepSoundMp3 from '../../assets/audios/beepSound.mp3'
import successSoundMp3 from '../../assets/audios/successSound.mp3'
import errorSoundMp3 from '../../assets/audios/errorSound.mp3'

import './styles.css'

export function Checkout() {
  const [order, setOrder] = useState()

  const [orderSearch, setOrderSearch] = useState('')
  const [itemSearch, setItemSearch] = useState('')
  const [itemQuantity, setItemQuantity] = useState('')

  const [items, setItems] = useState([])
  const [itemsInitial, setItemsInitial] = useState([])
  const [checkItems, setCheckItems] = useState([])

  const [checkoutPassword, setCheckoutPassword] = useState('')

  const [isLoadingSearchOrder, setIsLoadingSearchOrder] = useState(false)

  const inputSearchRef = useRef(null)
  const inputSearchItemRef = useRef(null)
  const buttonConfirmRef = useRef(null)

  const buttonIsEnable = items.length === 0 && checkItems.length > 0

  const beepSound = new Audio(beepSoundMp3)
  const successSound = new Audio(successSoundMp3)
  const errorSound = new Audio(errorSoundMp3)

  function resetStates() {
    setOrder()
    setOrderSearch('')
    setItemSearch('')
    setItems([])
    setCheckItems([])
    setIsLoadingSearchOrder(false)
  }

  async function handleConfirm() {
    try {
      await PedidosService.orderCheckout(order.pedido, localStorage.idusuario)

      successSound.play()
      return Swal.fire({
        icon: 'success',
        title: 'Pedido conferido com sucesso!',
        timer: 2000,
        timerProgressBar: true,
        willClose: () => {
          resetStates()
          inputSearchRef.current?.focus()
        },
      })
    } catch (err) {
      console.log(`Erro ao conferir o pedido: ${err}`)

      errorSound.play()
      return Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Não foi possível conferir o pedido, tente novamente mais tarde!',
        timer: 2000,
        timerProgressBar: true,
        willClose: () => {
          resetStates()
          inputSearchRef.current?.focus()
        },
      })
    }
  }

  async function handleSearchOrder() {
    setIsLoadingSearchOrder(true)

    try {
      const response = await apinode.get(
        `/pedido/search/${orderSearch}/${localStorage.idconta}`,
      )

      if (response.data.conf_checkout === 'S') {
        setOrderSearch('')
        errorSound.play()
        return Swal.fire('Erro', 'Pedido já foi conferido!', 'error')
      }

      setOrder(response.data)
      setItemsInitial(response.data.items)

      setItems(
        response.data.items.filter((item) => item.conferido_checkout !== 'S'),
      )

      setCheckItems(
        response.data.items
          .filter((item) => item.conferido_checkout === 'S')
          .map((item) => ({
            ...item,
            conferido: item.quantidade_nova,
          })),
      )

      setTimeout(() => {
        if (inputSearchItemRef.current) {
          window.scrollTo({
            top: inputSearchItemRef.current.offsetTop,
            behavior: 'smooth',
          })

          inputSearchItemRef.current.focus()
        }
      }, 500)
    } catch (error) {
      setOrderSearch('')

      errorSound.play()
      sendErrorApiMessage(error, 'Não foi possível buscar o pedido!')
    } finally {
      setIsLoadingSearchOrder(false)
    }
  }

  async function handleCheckItem(idItem) {
    try {
      await PedidosService.checkItem(idItem)
    } catch (err) {
      const itemOriginal = itemsInitial.find(
        (item) => item.codproduto === idItem,
      )

      setCheckItems((prevState) =>
        prevState.filter((item) => item.codproduto !== idItem),
      )

      setItems((prevState) => [...prevState, itemOriginal])

      sendErrorApiMessage(err, 'Não foi possível checar este item!')
    }
  }

  async function handleMoveItem(e) {
    e.preventDefault()

    const itemsFound = items.filter(
      (item) => item.sku === itemSearch || item.ean === itemSearch,
    )

    const itemsCheckFound = checkItems.filter(
      (item) => item.sku === itemSearch || item.ean === itemSearch,
    )

    if (itemsFound?.length === 0 && itemsCheckFound?.length === 0) {
      errorSound.play()
      setItemSearch('')
      return Swal.fire(
        'Erro',
        'EAN ou SKU não confere com os itens do pedido!',
        'error',
      )
    } else if (itemsFound?.length === 0 && itemsCheckFound?.length > 0) {
      errorSound.play()
      setItemSearch('')
      return Swal.fire('Erro', 'Item já foi checado!', 'error')
    }

    if (itemQuantity > 10) {
      const { value: adminPass } = await Swal.fire({
        title: 'Autorização do Administrador',
        input: 'password',
        inputLabel: 'Senha Administrador',
        inputPlaceholder: 'Digite sua senha',
        inputValidator: (value) => {
          if (!value) {
            return 'Digite a senha!'
          }
        },
      })

      if (adminPass && adminPass !== checkoutPassword) {
        errorSound.play()
        setItemSearch('')
        return Swal.fire('Erro', 'Senha incorreta!', 'error')
      } else if (!adminPass) {
        errorSound.play()
        setItemSearch('')
        return Swal.fire('Erro', 'Senha não informada!', 'error')
      } else {
        await removeQuantityItem(itemsFound, itemQuantity)
      }
    } else {
      await removeQuantityItem(itemsFound, itemQuantity)
    }

    setItemSearch('')
  }

  async function removeQuantityItem(itemsFound, itemQuantity) {
    for (const itemFound of itemsFound) {
      const indexCheck = checkItems.findIndex(
        (checkItem) =>
          checkItem.sku === itemFound.sku ||
          checkItem.codproduto === itemFound.codproduto,
      )

      const indexItem = items.findIndex(
        (item) =>
          item.sku === itemFound.sku ||
          item.codproduto === itemFound.codproduto,
      )

      const itemForCheckout = items[indexItem]

      if (Number(itemQuantity) > itemForCheckout.quantidade_nova) {
        errorSound.play()
        return Swal.fire('Erro', 'Maior do que a disponível!', 'error')
      }

      if (itemQuantity) {
        if (itemForCheckout.quantidade_nova - Number(itemQuantity) === 0) {
          await handleCheckItem(itemForCheckout.codproduto)

          setItems((prevState) =>
            prevState.filter((item, index) => index !== indexItem),
          )
        } else {
          setItems((prevState) =>
            prevState.with(indexItem, {
              ...itemForCheckout,
              quantidade_nova:
                itemForCheckout.quantidade_nova - Number(itemQuantity),
            }),
          )
        }

        beepSound.play()

        if (indexCheck > -1) {
          setCheckItems((prevState) =>
            prevState.with(indexCheck, {
              ...checkItems[indexCheck],
              conferido:
                checkItems[indexCheck].conferido + Number(itemQuantity),
            }),
          )
        } else {
          setCheckItems((prevState) => [
            ...prevState,
            {
              ...itemFound,
              conferido: Number(itemQuantity),
            },
          ])
        }
      } else {
        if (itemForCheckout.quantidade_nova - 1 === 0) {
          await handleCheckItem(itemForCheckout.codproduto)

          setItems((prevState) =>
            prevState.filter((item, index) => index !== indexItem),
          )
        } else {
          setItems((prevState) =>
            prevState.with(indexItem, {
              ...itemForCheckout,
              quantidade_nova: itemForCheckout.quantidade_nova - 1,
            }),
          )
        }

        beepSound.play()

        if (indexCheck > -1) {
          setCheckItems((prevState) =>
            prevState.with(indexCheck, {
              ...checkItems[indexCheck],
              conferido: checkItems[indexCheck].conferido + 1,
            }),
          )
        } else {
          setCheckItems((prevState) => [
            ...prevState,
            {
              ...itemFound,
              conferido: 1,
            },
          ])
        }
      }
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        const response = await apinode.get(
          `/checkout-password/${localStorage.idconta}`,
        )

        setCheckoutPassword(response.data)
      } catch (err) {
        sendErrorApiMessage(err, 'Erro ao buscar configurações!')
      }
    })()
  }, [])

  useEffect(() => {
    inputSearchRef.current?.focus()
  }, [])

  useEffect(() => {
    setTimeout(() => {
      if (items?.length === 0 && checkItems?.length > 0) {
        buttonConfirmRef.current?.click()
      }
    }, 1000)
  }, [checkItems?.length, items?.length])

  return (
    <div
      style={{
        height: '100%',
        overflowY:
          items.length > 0 || checkItems.length > 0 ? 'visible' : 'hidden',
        position: 'relative',
      }}
    >
      <Navbar />
      <div className="mt-page">
        <h1 style={{ textAlign: 'center', fontWeight: 'bold' }}>Checkout</h1>

        <div className="center">
          <Form.Label>Número do Pedido</Form.Label>
          <section className="group">
            <Form.Control
              ref={inputSearchRef}
              value={orderSearch}
              onChange={(e) => setOrderSearch(e.target.value)}
              placeholder="Digite o número do pedido..."
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault()

                  if (e.target.value.length > 0) {
                    handleSearchOrder()
                  }
                }
              }}
              style={{
                width: 400,
              }}
            />

            <CustomButton
              onClick={handleSearchOrder}
              isLoading={isLoadingSearchOrder}
              isDisabled={!orderSearch}
            >
              <Search />
            </CustomButton>
          </section>

          {order?.pedido && (
            <article className={`order-info ${order?.pedido && 'enter'}`}>
              <p>
                <strong>Pedido:</strong> {order?.pedido}
              </p>

              <p>
                <strong>Cliente:</strong> {order?.cliente}
              </p>

              <p>
                <strong>Envio:</strong> {order?.ship}
              </p>

              <p>
                <strong>Data:</strong> {formatDate(order?.data)}
              </p>

              <p>
                <strong>Conferente Mobile:</strong> {order?.conferente}
              </p>

              <p>
                <strong>Status:</strong> {order?.status}
              </p>
            </article>
          )}
        </div>

        {(items.length > 0 || checkItems.length > 0) && (
          <div className="conference">
            <div
              className="center"
              style={{
                marginBottom: 50,
              }}
            >
              <Form.Label>Digite o SKU ou EAN para conferir:</Form.Label>

              <div className="group">
                <Form.Control
                  value={itemQuantity}
                  onChange={(e) => setItemQuantity(e.target.value)}
                  placeholder="Qtd"
                  style={{
                    width: 80,
                    marginRight: 10,
                  }}
                />

                <Form.Control
                  ref={inputSearchItemRef}
                  value={itemSearch}
                  onChange={(e) => setItemSearch(e.target.value)}
                  placeholder="SKU ou EAN..."
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault()

                      if (e.target.value.length > 0) {
                        handleMoveItem(e)
                      }
                    }
                  }}
                  style={{
                    width: 400,
                  }}
                />

                <CustomButton
                  type="button"
                  isDisabled={!itemSearch}
                  onClick={handleMoveItem}
                  styles={{
                    width: 38,
                  }}
                >
                  <PatchCheckFill />
                </CustomButton>
              </div>
            </div>

            <section>
              <main>
                <h1>Itens do pedido:</h1>

                <div className="itens">
                  {items.length > 0 ? (
                    items?.map((item) => (
                      <article
                        key={item.codproduto}
                        className={`order-item`}
                      >
                        <main>
                          <p>
                            <strong>SKU/Código:</strong> {item?.sku}
                          </p>

                          <p>
                            <strong>Descrição:</strong> {item?.descricao}
                          </p>

                          <p>
                            <strong>Cod. Interno:</strong> {item?.codproduto}
                          </p>

                          <p>
                            <strong>Ean:</strong>{' '}
                            {item?.ean || item?.codbarras || 'Sem EAN!'}
                          </p>

                          <p>
                            <strong>Qtd:</strong> {item?.quantidade_nova}
                          </p>
                        </main>
                      </article>
                    ))
                  ) : (
                    <div
                      className="center"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '100px',
                      }}
                    >
                      <p>Tudo certo por aqui :D</p>
                    </div>
                  )}
                </div>
              </main>

              <main>
                <h1>Itens conferidos:</h1>

                <div className="itens">
                  {checkItems?.map((item) => (
                    <article
                      key={item.codproduto}
                      className={`order-item`}
                    >
                      <main>
                        <p>
                          <strong>SKU/Código:</strong> {item?.sku}
                        </p>

                        <p>
                          <strong>Descrição:</strong> {item?.descricao}
                        </p>

                        <p>
                          <strong>Cod. Interno:</strong> {item?.codproduto}
                        </p>

                        <p>
                          <strong>Ean:</strong>{' '}
                          {item?.ean || item?.codbarras || 'Sem EAN!'}
                        </p>

                        <p>
                          <strong>Conferido:</strong> {item?.conferido}
                        </p>
                      </main>

                      <footer>
                        <OverlayTrigger
                          overlay={
                            <Tooltip>
                              {item.conferido < item.quantidade_nova
                                ? 'Em Andamento'
                                : 'Concluído'}
                            </Tooltip>
                          }
                        >
                          <div
                            style={{
                              background:
                                item.conferido < item.quantidade_nova
                                  ? '#f58f06'
                                  : '#06a43b',
                            }}
                          >
                            {item.conferido < item.quantidade_nova ? (
                              <Clock color="white" />
                            ) : (
                              <CheckCircle color="white" />
                            )}
                          </div>
                        </OverlayTrigger>
                      </footer>
                    </article>
                  ))}
                </div>
              </main>
            </section>
          </div>
        )}
      </div>

      <CustomButton
        ref={buttonConfirmRef}
        title="Confirmar"
        onClick={handleConfirm}
        isDisabled={!buttonIsEnable}
        color="#17b11e"
        styles={{
          position: 'fixed',
          right: 0,
          marginBottom: 5,
          bottom: 0,
        }}
      >
        <CheckCircleFill />
      </CustomButton>
    </div>
  )
}
